import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7eee99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-explore-now-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "block-explore-now-title"
}
const _hoisted_3 = { class: "block-explore-now" }
const _hoisted_4 = { class: "block-explore-now-image" }
const _hoisted_5 = { class: "block-explore-now-button" }

import UiButton from "@/shared/ui/ui-button/ui-button.vue";

/** События отправляемые наверх */

export default /*#__PURE__*/_defineComponent({
  __name: 'block-explore-now',
  props: {
  /** Заголовок  */
  title: {
    type: String,
    default: "",
  },
  link: {
    type: String,
    default: "",
  },
  image: {
    type: String,
    default: "",
  },
textButton: {
    type: String,
    default: "",
  },
},
  emits: ["onClick"],
  setup(__props, { emit: emits }) {

const props = __props;




const onClick=()=>{
  emits('onClick')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          style: _normalizeStyle({backgroundImage:'url('+__props.image+')'}),
          class: "explore-now-image"
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (__props.link)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "app-footer-block-text",
              to: {name:__props.link}
            }, {
              default: _withCtx(() => [
                _createVNode(UiButton, {
                  class: "explore-now-button",
                  color: "#71B92F",
                  height: "45"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.textButton), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(UiButton, {
              key: 1,
              class: "explore-now-button",
              color: "#71B92F",
              height: "45",
              onClick: onClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.textButton), 1)
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}
}

})